import type { Logger } from '#src/assets/lib/logger.ts'

export function initGoogleConsentMode(log: Logger['log']): void {
  // Pages without gtag get no Consent Mode default: the Lenus lead form's
  // Firebase SDK adopts an existing window.gtag instead of creating its own,
  // and its analytics must not depend on a gtag defined by this script. See
  // "Google Consent Mode: known limitations" in the README.
  if (!window.gtag) {
    log('gtag not defined, skipping Google Consent Mode default')
    return
  }

  const dataLayer = window.dataLayer || []
  const hasTracking = dataLayer.some(
    item =>
      Array.isArray(item) && (item[0] === 'config' || item[0] === 'event'),
  )

  if (hasTracking) {
    console.warn(
      '[Lenus Cookie Consent] Google Consent Mode should be initialized before gtag config/event calls. Refer to https://developers.google.com/tag-platform/security/guides/consent for more information.',
    )
  }

  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 2000,
  })

  log('Google Consent Mode initialized with default: denied')
}

export function updateGoogleConsentMode(
  consents: Record<string, boolean>,
  log: Logger['log'],
): void {
  if (!window.gtag) {
    log('Google Consent Mode not available, skipping update')
    return
  }

  const consentUpdate: Record<string, string> = {
    ad_storage: consents.marketing ? 'granted' : 'denied',
    analytics_storage: consents.analytics ? 'granted' : 'denied',
  }

  window.gtag('consent', 'update', consentUpdate)
  log('Google Consent Mode updated:', consentUpdate)
}
